import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Star, Quote, MessageSquare } from "lucide-react";
import { TESTIMONIOS } from "../data/content";
import SEO from "../components/SEO";

export default function Testimonios() {
  return (
    <div className="max-w-7xl mx-auto px-4 py-12 md:py-16">
      <SEO
        title="Testimonios de pacientes"
        description="Historias reales de recuperación y bienestar de pacientes del Dr. César S. Martínez Maldonado, psiquiatra en Xalapa, Veracruz."
        canonical="/testimonios"
      />
      <Link to="/" className="inline-flex items-center gap-2 text-slate-500 hover:text-cyan-700 transition mb-8 text-sm">
        <ArrowLeft size={16} /> Volver al inicio
      </Link>

      <div className="text-center mb-12">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-cyan-50 text-cyan-700 text-sm font-medium mb-4">
          <MessageSquare size={16} /> Testimonios
        </div>
        <h1 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
          Historias reales de recuperación
        </h1>
        <p className="text-xl text-slate-600 max-w-2xl mx-auto">
          Pacientes y familias que han confiado en nuestra atención profesional comparten sus experiencias.
        </p>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {TESTIMONIOS.map((t, i) => (
          <div key={i} className="bg-white rounded-2xl p-7 border border-slate-100 shadow-sm hover:shadow-lg transition-all relative overflow-hidden">
            <Quote className="absolute top-4 right-4 text-cyan-100" size={56} />
            <div className="relative">
              <div className="flex gap-0.5 mb-4">
                {Array.from({ length: t.rating }).map((_, idx) => (
                  <Star key={idx} size={16} className="fill-yellow-400 text-yellow-400" />
                ))}
              </div>
              <p className="text-slate-700 leading-relaxed mb-6">"{t.text}"</p>
              <div className="flex items-center gap-3 pt-4 border-t border-slate-100">
                <div className="w-11 h-11 rounded-full bg-gradient-to-br from-cyan-500 to-teal-500 flex items-center justify-center text-white font-bold">
                  {t.name.charAt(0)}
                </div>
                <div>
                  <div className="font-semibold text-slate-900">{t.name}</div>
                  <div className="text-xs text-slate-500">{t.role}</div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-16 bg-gradient-to-br from-cyan-50 via-white to-teal-50 rounded-2xl p-8 md:p-12 text-center border border-cyan-100">
        <div className="inline-flex gap-1 mb-3">
          {Array.from({ length: 5 }).map((_, i) => (
            <Star key={i} size={22} className="fill-yellow-400 text-yellow-400" />
          ))}
        </div>
        <h3 className="text-2xl md:text-3xl font-bold text-slate-900 mb-3">¿Eres paciente y quieres compartir tu experiencia?</h3>
        <p className="text-slate-600 mb-6 max-w-2xl mx-auto">
          Tu testimonio puede ayudar a otras personas que atraviesan situaciones similares. Contáctanos y compartiremos tu historia (con tu permiso y preservando tu privacidad).
        </p>
        <Link to="/contacto" className="inline-block px-6 py-3 rounded-full bg-gradient-to-r from-cyan-600 to-teal-600 text-white font-semibold hover:scale-105 transition">
          Compartir mi experiencia
        </Link>
      </div>
    </div>
  );
}
